import { connect, mapReadPretty } from '@formily/react'

import { UploadFile as CommonUploadFile } from '@eastcoal/common/components/UploadFile'

export const UploadFile = connect(
  CommonUploadFile,
  mapReadPretty(CommonUploadFile, { readPretty: true })
)
